import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  BooleanField,
  ChipField,
  ReferenceField,
  TopToolbar,
  EditButton,
  DeleteButton,
} from "react-admin";
import { SubscriptionLimiterPlanInfo } from "./SubscriptionLimiterPlanInfo";

const SubscriptionLimiterShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteButton />
  </TopToolbar>
);

export const SubscriptionLimiterShow = () => {
  return (
    <Show actions={<SubscriptionLimiterShowActions />} title="Лимитер подписки">
      <SimpleShowLayout>
        <TextField source="name" label="Название" />
        <ChipField source="type" label="Тип" />
        <TextField source="description" label="Описание" />
        <NumberField source="limitValue" label="Значение лимита" />
        <ChipField source="period" label="Период" />
        <BooleanField source="isHardLimit" label="Жесткий лимит" />
        <BooleanField source="isActive" label="Активен" />

        <SubscriptionLimiterPlanInfo />
      </SimpleShowLayout>
    </Show>
  );
};
